import clsx from 'clsx';

import { createPolymorphicComponent } from '~/helpers/typescript-helpers';

import styles from './productCardPlaceholder.module.css';

export const ProductCardPlaceholder = createPolymorphicComponent(({ className, as: ComponentType = 'div', ...rest }, ref) => (
	<ComponentType
		ref={ref}
		className={clsx(styles.root, className)}
		{...rest}
	/>
));
